<section>
  <h2 class="pull-left mt0">Services</h2>
  @if (statusLink) {
  <a [routerLink]="statusLink" class="btn-link">View status &raquo;</a>
  } @if (workflows) { @for (workflow of workflows; track workflow) {
  <div>
    @if (workflow.services.length > 0) {
    <div class="workflow">
      <h2 class="block-header">{{ workflow.name }}</h2>
      <div class="block-content">
        @for (service of workflow.services; track service) { @if
        (isVisible(service.id)) {
        <div class="service">
          @if (toServiceLink) {
          <a [routerLink]="toServiceLink({ serviceId: service.id })">
            @for (progress of service.progress; track progress) {
            <service-progress-status
              [progress]="progress"
            ></service-progress-status>
            }
            {{ service.name }}
          </a>
          } @if (!toServiceLink) {
          <span>
            @for (progress of service.progress; track progress) {
            <service-progress-status
              [progress]="progress"
            ></service-progress-status>
            }
            {{ service.label }}
          </span>
          }
        </div>
        } }
      </div>
    </div>
    }
  </div>
  } } @if (hhgWorkflow) {
  <div class="workflow">
    <h2 class="block-header">{{ hhgWorkflow.name }}</h2>
    <div class="block-content">
      @for (service of hhgWorkflow.services; track service) {
      <div class="service">
        @if (toServiceLink) {
        <a [routerLink]="toServiceLink({ serviceId: service.id })">
          @for (progress of service.progress; track progress) {
          <service-progress-status
            [progress]="progress"
          ></service-progress-status>
          }
          {{ service.label }}
        </a>
        } @if (!toServiceLink) {
        <span>
          @for (progress of service.progress; track progress) {
          <service-progress-status
            [progress]="progress"
          ></service-progress-status>
          }
          {{ service.label }}
        </span>
        }
      </div>
      }
    </div>
  </div>
  } @if (!hasServices) {
  <no-data>
    <p>There are no services associated with this assignment.</p>
  </no-data>
  }
</section>
